import Konva from "konva";
import { memo, useContext, useEffect, useRef, useState } from "react";
import { Layer, Stage, Image as KonvaImage } from "react-konva";
import { QuestionnaireContext } from "../../../StateManagment/Questionnaire";

const postageStampImg = new Image();
postageStampImg.src = '/canvas/postcard/postage_stamp.png'; 
const postageStampImgSize = 120;

const PostCard = ({
    isVisible,
}) => {

    const containerRef = useRef(null);
    const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

    const { isTransitioning, setTransitionDuration } = useContext(QuestionnaireContext);

    /** @type {React.Ref<Konva.Image>} */
    const objectRef = useRef(null);

    useEffect(() => {
        if (!isVisible) return;
        const resize = () => {
            if (containerRef.current) {
                const { clientWidth, clientHeight } = containerRef.current;
                setDimensions({ width: clientWidth, height: clientHeight });
            }
        };
        resize(); // Initial size
        window.addEventListener("resize", resize);

        return () => window.removeEventListener("resize", resize);
    }, [containerRef, isVisible]);

    const w = dimensions.width;
    const h = dimensions.height;

    useEffect(() => {
        if (isVisible) {
            setTransitionDuration(2800);
        }
    }, [isVisible, setTransitionDuration]);

    useEffect(() => {
        if (!isVisible) return;
        if (!objectRef.current) return;
        if (!isTransitioning) return;
        if (w <= 0) return;
        
        const obj = objectRef.current;

        const finalState = {
            position: {
                x: w - postageStampImgSize/2 - 30,
                y: 0 + postageStampImgSize/2 + 30,
            }
        };

        const isMobile = window.innerWidth < 768;

        if (isMobile) {
            finalState.position.x = w - postageStampImgSize/2 - 0;
            finalState.position.y = 0 + postageStampImgSize/2 + 15;
        }

        /** @type {Konva.Tween[]} */
        const tweens = [];

        /**
         * @param {Konva.TweenConfig} tweenConfig 
         */
        const createTween = (tweenConfig) => {
            const tween = new Konva.Tween(tweenConfig);
            tweens.push(tween);
            tween.play();
        }

        /* Initial state */ 
        obj.x(w/2);
        obj.y(h);
        obj.scaleX(0);
        obj.scaleY(0);

        createTween({
            node: obj,
            duration: 0.5,
            x: w/2,
            y: h/2,
            scaleX: 2,
            scaleY: 2,
            easing: Konva.Easings.EaseInOut,
            onFinish: () => {
                if (!obj) return;

                createTween({
                    node: obj,
                    /* Delay/wait */
                    duration: 0.8,
                    easing: Konva.Easings.EaseInOut,
                    onFinish: () => {
                        createTween({
                            node: obj,
                            duration: 0.5,
                            x: finalState.position.x,
                            y: finalState.position.y + 10,
                            scaleX: 1.5,
                            scaleY: 1.5,
                            easing: Konva.Easings.EaseIn,
                            onFinish: () => {
                                obj.to({
                                    duration: 1.0,
                                    y: finalState.position.y,
                                    scaleX: isMobile ? 0.85 : 1.0,
                                    scaleY: isMobile ? 0.85 : 1.0,
                                    easing: Konva.Easings.ElasticEaseOut,
                                });
                            },
                        });
                    },
                });
            }
        });

        return () => {
            tweens.forEach(tween => {
                if (tween) {
                    tween.pause();
                }
            });
        }
    }, [isVisible, w, h, objectRef, isTransitioning, setTransitionDuration]);

    if (!isVisible) {
        return null; // Don't render anything if not visible
    }

    return (
        <>
            <div className="post-card-address">
                <hr style={{ visibility: 'hidden' }} />
                <hr />
                <hr />
                <hr />
                <hr />
            </div>
            <div style={{ pointerEvents: 'none', 
                position: 'absolute', zIndex: -1, 
                top: 0, left: 0, 
                width: '100%', height: '100%', 
                backgroundImage: 'url("/canvas/postcard/postcard.png")', 
                backgroundSize: 'cover', 
                backgroundPosition: 'center', 
                backgroundRepeat: 'no-repeat',
                boxShadow: 'inset 0 0 0 2000px rgba(255, 255, 255, 0.6)'
            }}>
            </div>
            <div ref={containerRef} style={{ pointerEvents: 'none', 
                position: 'absolute', zIndex: 10, 
                top: 0, left: 0, 
                width: '100%', height: '100%', 
                }}>
                <Stage width={dimensions.width} height={dimensions.height}>
                    <Layer visible={isTransitioning}>
                        <KonvaImage
                            ref={objectRef}
                            // x={w - 30}
                            // y={0 + 30}
                            width={postageStampImgSize}
                            height={postageStampImgSize}
                            image={postageStampImg}
                            offset={{ x: postageStampImgSize/2, y: postageStampImgSize/2 }}
                        />
                    </Layer>
                </Stage>
            </div>
            <style>
                {`
                .paragraph-container {
                    display: flex;
                }
                .post-card-address {
                    color: #333333;
                    padding: 20px;
                    box-sizing: border-box;
                    width: 45%;
                }
                .post-card-address hr {
                    height: 1px;
                    margin: 30px 0;
                    width: 100%;
                    border: none;
                    background-color: #333333;
                }
                .field-title-container, 
                .explainer-container {
                    width: 85%; 
                }
                .explainer-container p {
                    color: #333333 !important;
                }
                .field-title-container h2 {
                    color: #333333 !important;
                }
                .paragraph-container p {
                    color: #333333 !important;
                }
                textarea {
                    width: 55%;
                }
                .ai-support-icon {
                    filter: brightness(0%);
                }
            
                @media (max-width: 768px) {
                    textarea {
                        width: 94%; /* Original size */
                    }
                    .post-card-address {
                        display: none;
                    }
                    .field-title-container, 
                    .explainer-container {
                        width: 75%;
                    }
                    .paragraph-container textarea {
                        height: 150px;
                    }
                }
                `}
            </style>
        </>
    );

    // return (
    //     <>
    //         <div className="post-card-address">
    //             <hr></hr>
    //             <hr></hr>
    //             <hr></hr>
    //             <hr></hr>
    //         </div>
    //         {/* <div className="post-card-hand"
    //             style={{
    //                 position: 'absolute',
    //                 top: '50%', left: '-10%',
    //                 // transform: 'translate(-50%, -50%)',
    //                 width: '100px', height: '100px',
    //                 backgroundImage: 'url("/canvas/hand_asset.png")',
    //                 backgroundSize: 'cover',
    //                 pointerEvents: 'none'
    //             }}
    //         ></div> */}
    //         <div className="post-card" 
    //             style={{ 
    //                 display: 'block',
    //                 position: 'absolute',
    //                 zIndex: -1,
    //                 top: 0, left: 0,
    //                 width: '100%', height: '100%',
    //                 backgroundImage: 'url("/canvas/postcard/postcard.png")',
    //                 backgroundSize: 'cover',
    //             }}
    //             >
    //         </div>
    //         <style>
    //             {`
    //             .paragraph-container {
    //                 display: flex;
    //             }
    //             .post-card-address {
    //                 color: #333333;
    //                 padding: 20px;
    //                 box-sizing: border-box;
    //                 width: 45%;
    //             }
    //             .post-card-address hr {
    //                 height: 1px;
    //                 margin: 30px 0;
    //                 width: 100%;
    //                 border: none;
    //                 background-color: #333333;
    //             }
    //             .explainer-container p {
    //                 color: #333333 !important;
    //             }
    //             .field-title-container h2 {
    //                 color: #333333 !important;
    //             }
    //             .paragraph-container p {
    //                 color: #333333 !important;
    //             }
    //             textarea {
    //                 width: 55%;
    //             }
                
    //             @media (max-width: 768px) {
    //                 textarea {
    //                     width: 94%; /* Original size */
    //                 }
    //                 .post-card-address {
    //                     display: none;
    //                 }    
    //             }
    //             `}
    //         </style>
    //     </>
    // );
}

export default PostCard;

// export default memo(PostCard, (prevProps, nextProps) => {
//     return prevProps.cols === nextProps.cols &&
//         prevProps.rows === nextProps.rows &&
//         prevProps.responses === nextProps.responses;
// });
